import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setEditor} from './slice'
import {
	useMerchandiseItems,
	useMerchandiseOrders
} from './hooks'
import CenteredLoader from '../CenteredLoader/CenteredLoader'
import Order from './Order/Order'
import Item from './Item/Item'
import Cart from './Cart/Cart'
import PurchaseModal from './PurchaseModal/PurchaseModal'
import Editor from './Editor/Editor'
import styles from './Merchandise.module.css'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import useStripeAccount from '../../hooks/useStripeAccount'
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import useCurrentUser from '../../hooks/useCurrentUser'

const Merchandise = () => {
	const dispatch = useDispatch()
	const {status:itemsStatus,ids:itemIds} = useMerchandiseItems()
	const {status:ordersStatus,ids:orderIds} = useMerchandiseOrders()
	const handleToggleEditor = () => { 
		dispatch(setEditor({id:false,show:true}))
	}
	const user = useCurrentUser()
	const stripePromise = useStripeAccount(user?.trainer_stripe_account)


	return (
		<div className="pb-5">
			<h1>Merchandise</h1>
			<hr/>
			<Tabs defaultActiveKey="items" id="merchandise-tabs" className="mb-3">
				<Tab eventKey="items" title="Items">
					{
						itemsStatus !== 'idle' ? 
						<CenteredLoader /> :
						<div>
							{user.account_type !== 'client'&&
								<div className="text-right mb-2">
									<Button 
										onClick={handleToggleEditor}
										variant="outline-success"
									>
										Add New Item
									</Button>
								</div>
							}
							<div className={styles.Controls}>
								<Form.Control placeholder="search"/>
							</div>
							<div className={styles.ItemsGrid}>
								{itemIds.map( id => <Item key={id} id={id}/> )}
							</div>
						</div>
					}
				</Tab>
				<Tab eventKey="orders" title="Orders">
					{
						ordersStatus !== 'idle' ? 
						<CenteredLoader /> :
						<div>
							<div className={styles.Controls}>
								<Form.Control placeholder="search"/>
							</div>
							<div className={styles.OrdersTable}>
								<div className={styles.OrdersHeader}>
									<div className="d-flex align-items-center">
										<div>
											Item
										</div>
										<div className="ml-auto" style={{width:'60px',textAlign:'right'}}>
											Fulfilled
										</div>
									</div>
								</div>
								{orderIds.map( id => <Order key={id} id={id}/> )}
							</div>
						</div>
					}
				</Tab>
				{user.account_type==='client'&&
					<Tab 
						eventKey="cart" 
						title={
							<span>
								Cart <i className="fas fa-shopping-cart ml-1"/>
							</span>
						}
					>
						<Cart/>
					</Tab>
				}
			</Tabs>
			<Editor/>
			
			<Elements stripe={stripePromise}>
				<ElementsConsumer>
					{({ elements, stripe }) => (
						<PurchaseModal
							elements={elements}
							stripe={stripe}
						/>
					)}
				</ElementsConsumer>
			</Elements>
		</div>
	)
}


export default Merchandise